import { getBinders } from "@/api/binders";
import AuthModal from "@/components/AuthModal";
import Hero from "@/components/Hero";
import MobilePWA from "@/components/MobilePWA";
import { MainLayout } from "@/layouts/MainLayout";
import { MainLayoutMobileHeader } from "@/layouts/MainLayoutMobileHeader";
import { useEffect, useState } from "react";

const Index = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<"login" | "signup">("login");

  const handleAuthClick = (mode: "login" | "signup" = "login") => {
    setAuthMode(mode);
    setIsAuthModalOpen(true);
  };

  useEffect(() => {
    getBinders();
  }, []);

  return (
    <MainLayout>
      <MainLayoutMobileHeader header="Home" />
      <Hero onAuthClick={() => handleAuthClick("login")} />
      <MobilePWA />

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        mode={authMode}
        onModeChange={setAuthMode}
      />
    </MainLayout>
  );
};

export default Index;
